import React, { createContext, useState } from 'react';

/*
 * Context for managing the global loading state in the application.
 * It provides the `LoadingContext` and `LoadingProvider` so that other components can access
 * and modify the loading state (`isLoading`), allowing a global loading indicator to be displayed
 * during asynchronous operations.
 */

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
